<template>
  <div>

    <div class="user-options-wrap">
      <v-header>
        <div class="flex flex-end">
          <v-dropdown :data="userOptions" trigger="click" @item-click="userAction" v-if="user">
            <a href="javascript:void(0)" class="ant-dropdown-link ant-dropdown-trigger">
            Welcome! {{user.displayName || user.email}} <v-icon type="down"></v-icon>
            </a>
          </v-dropdown>
        </div>
      </v-header>
    </div>

    <div class="question">
      <div>I want to use the application as a</div>
    </div>

    <div class="user-type-wrap">
      <div class="user-type-select" @click="() => updateUser({type: 'Student', status: 'Active'})">
        <img src="../assets/student.png" width="180" />
        <div class="label">Student</div>
      </div>
      <div class="user-type-select" @click="() => updateUser({type: 'Associate', status: 'Registered'})">
        <img src="../assets/associate.png" width="180" />
        <div class="label">Associate</div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import fb from '@/firebase'

export default {
  name: 'FirstInfo',
  data () {
    return {
      userOptions: [
        {content: 'Notification'},
        {content: 'Profile'},
        {content: 'Logout'}
      ]
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
    user: {
      handler (val) {
        console.log(val)
      },
      immediate: true
    }
  },
  methods: {
    userAction (data) {
      if (data.content === 'Logout') {
        fb.logout()
      }
    },
    updateUser (payload) {
      this.$store.dispatch('setUserBasicDetails', {id: this.user.uid, payload: payload})
    }
  }
}
</script>

<style scoped>
.ant-layout-header {
  background: transparent;
  padding: 0;
  height: 34px;
  line-height: 34px;
}
.ant-dropdown {
  top: 34px;
}
.user-options-wrap {
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}
.question {
  font-size: 38px;
  margin-bottom: 70px;
  display: flex;
  justify-content: center;
}
.user-type-wrap {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
}
.user-type-select {
  height: 300px;
  width: 300px;
  background: blueviolet;
  border-radius: 50%;
  border: 3px solid grey;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.user-type-select .label {
  color: ivory;
  font-size: 22px;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/FirstInfo.vue